<template>
  <div>
    <div class="configure-header has-text-centered">
      <div class="is-size-1">
        {{ $t('configure_domain.title') }}
      </div>
      <div class="is-size-4">
        {{ $t('configure_domain.header') }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ConfigureDomainHeader'
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.configure-header {
  margin-top: 8px;
  margin-bottom: 20px;
  width: 100%;
  min-height: 150px;
  color: white;
  padding: 35px 40px 20px 40px;
  background-color: var(--primary-color);

}

@media only screen and (max-width: 1023px) {
  .configure-header {
    font-size: 1.5em;
    padding: 80px;
  }
}
</style>
